import { ServiceItems } from "../location/info/service/ServiceItems";


export const ServiceTab = ({ location, locationsIds }: any) => {
    return (
        <>
            <ServiceItems serviceItems={location.serviceItems} locationsIds={locationsIds} />
        </>
    );
};